/**
 * @specification
 * Adds role 'alert' to 'body' slot.
 * Adds attribute 'aria-live=polite' to 'body' slot.
 */
export var alertWarningBehavior = function alertWarningBehavior(props) {
  return {
    attributes: {
      body: {
        role: 'alert',
        'aria-live': 'polite'
      },
      dismissAction: {
        'aria-describedby': props.bodyId
      }
    }
  };
};
//# sourceMappingURL=alertWarningBehavior.js.map
